import { css } from '@emotion/react';
import sickBabyBackground from '@assets/images/sick_baby_background.png';

export const container = css({
  width: 1920,
  height: 1080,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center'
});

export const backgroundImage = css({
  backgroundImage: `url(${sickBabyBackground})`,
  position: 'absolute',
  width: '100%',
  height: '100%',
  filter: 'blur(14px)',
  zIndex: -1
});
